import { Loader } from '../spinner/spinner';
import { isWhiteLabel } from 'shared/util/utility';

interface IButtonProps {
	buttonTitle: string;
	btnClassName: string;
	isSubmitLoading?: boolean;
	disabled?: boolean;
	onButtonClick?: () => void;
}

interface IClassObj {
	[key: string]: string;
}

const loadingClass: IClassObj = {
	'primary-button': 'text--white',
	'secondary-button': 'text--black'
};

const CustomButton = ({ buttonTitle, btnClassName, isSubmitLoading, disabled, onButtonClick }: IButtonProps) => {
	return (
		<button
			className={`${btnClassName} ${
				isWhiteLabel && btnClassName.includes('primary-button') ? 'white-label-primary-btn' : ''
			}`}
			type='submit'
			data-testid='submit'
			onClick={onButtonClick}
			disabled={disabled || false}
		>
			{isSubmitLoading ? (
				<Loader className={isWhiteLabel ? 'text--black' : loadingClass[btnClassName] || 'text--white'} />
			) : (
				buttonTitle
			)}
		</button>
	);
};

export default CustomButton;
